import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { SitePayload } from 'app/types/park/site'

export const createSite = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.LIST}`,
    async ({ request }) => {
        const payload = await request.json()

        const payloadParsed = SitePayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return new HttpResponse(null, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        const siteCreated = {
            id: 999,
            ...payloadParsed.data,
        }

        return HttpResponse.json(siteCreated, {
            status: StatusCodes.CREATED,
        })
    },
)
